import { useContext } from 'react';
import { userContext } from '../context/userContext';

export const useSession = () => {
  const { user } = useContext(userContext);
  return user;
};

export default useSession;
